import { CONTACT_EMAIL } from './contact';

export const LEGAL_SITE_NAME = 'TPV Hosty';
export const LEGAL_DOMAIN = 'tpvhosty.com';
export const LEGAL_SITE_URL = `https://${LEGAL_DOMAIN}`;
export const LEGAL_CONTACT_EMAIL = CONTACT_EMAIL;
export const LEGAL_LAST_UPDATED = '12 de junio de 2026';

/** Titular del servicio (autónomo / persona física). */
export const LEGAL_BUSINESS_NAME = 'Kevin Wegener Antolinez';
export const LEGAL_TAX_ID = '17483129R';
export const LEGAL_ADDRESS = 'Calle Mezquita 15, 04720 Aguadulce, Almería, España';

export const LEGAL_URLS = {
  privacy: '/privacidad',
  terms: '/condiciones',
  dataDeletion: '/eliminacion-datos',
} as const;
